<template>
  <div :style="style" v-html="newTxet || basicConf.text.replace('{{newtest}}','')" />
</template>
      <script>
    export default {
        name: 'MarsText',
        props: {
            editableData: {
                type: Object,
                default: function() {
                    return {
                        basic: {}
                    }
                }
            }
        },
        data() {
            return {
                newTxet: ''
            }
        },
        computed: {
            basicConf: function() {
                return this.editableData.basic
            },
            style: function() {
                var t = this.basicConf.font || {},
                e = t.fontSize,
                n = {
                    fontSize: e + 'px',
                    textAlign: t.textAlign,
                    fontWeight: t.fontWeight,
                    fontFamily: t.fontFamily,
                    textDecoration: t.textDecoration,
                    lineHeight: t.lineHeight,
                    color: this.basicConf.color
                }
                if (this.basicConf.textShadow) {
                    var o = this.basicConf.textShadow
                    n.textShadow = ''.concat(o.x, 'px ').concat(o.y, 'px ').concat(o.blur, 'px ').concat(o.color)
                }
                if ((n.fontSize = isNaN(Number(e)) ? e : e / 75 + 'rem', this.basicConf.textShadow)) {
                    var r = this.basicConf.textShadow
                    n.textShadow = ''.concat(r.x / 75, 'rem ').concat(r.y / 75, 'rem ').concat(r.blur / 75, 'rem ').concat(r.color)
                }
                return n
            }
        },
        mounted: function() {

        },
        methods: {
            settext(val) {
                var de = this.basicConf.text || ''
                var ppkey = '{{newtest}}'
                if (de.indexOf(ppkey) > -1 && val !== undefined) {
                    return de.replace(ppkey, val)
                }
                return val || de.replace(ppkey, '')
            },
            changeText(value) {
                let obj = value.text
                if (this.basicConf.textKey) {
                    const keys = this.basicConf.textKey.split('.')
                    while (keys.length > 0) {
                        const key = keys.shift()
                        if (obj[key] !== undefined) {
                            obj = obj[key]
                        } else {
                            return this.newTxet = this.settext(value.text)
                        }
                    }
                }
                return this.newTxet = this.settext(obj)
            }
        }
    }
    </script>

    <style lang="scss" scoped>
        div{
            white-space: 'pre-wrap ';
            word-break: 'break-all'
            img{
                width: 100%;
            }
        }
    </style>

